import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { useWmgSession } from '~/modules/auth/hooks/useWmgSession';

import { OrganizationQueryKeys } from '../config/queryKeys';
import { getRequestHeaders } from '../lib/headers';
import { LegacyCoopClient } from '../lib/LegacyCoopClient';
import {
  type OrganizationListResponse,
  OrganizationListResponseSchema,
} from '../lib/schemas';
import type { PresetUseQueryOptions } from '../lib/types';

export function useOrganizationList<TData = OrganizationListResponse>(
  options?: PresetUseQueryOptions<OrganizationListResponse, TData>,
) {
  const session = useWmgSession();

  const { data, ...query } = useQuery({
    queryKey: OrganizationQueryKeys.list(),
    queryFn: async () => {
      const responseData = await LegacyCoopClient.get(
        'users/list-of-organizations',
        {
          headers: getRequestHeaders(session.token),
        },
      ).json();

      return OrganizationListResponseSchema.parse(responseData);
    },
    placeholderData: keepPreviousData,
    ...options,
  });

  return { organizationList: data, ...query };
}
